module.exports = __webpack_public_path__ + "img/thumbnail_KingPenguin_f_xanthic.1fc72fec.png";